var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_67",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "40.668 88.632 49.769 88.632 59.332 88.632" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50", y1: "88.323", x2: "50", y2: "72.55" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m70.652,51.898c0,11.411-9.25,20.652-20.652,20.652s-20.652-9.24-20.652-20.652c0-4.382,1.363-8.451,3.7-11.791.185-.253.38-.497.555-.759,0,0,.01-.01.01-.019,2.697-3.846,4.284-8.52,4.284-13.573v-7.098h24.205v7.098c0,5.053,1.587,9.727,4.284,13.573,0,.01.01.019.01.019.175.263.37.506.555.759,2.337,3.34,3.7,7.41,3.7,11.791Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m34.42,38.025l4.038-1.602c3.455-1.37,7.253-1.52,10.799-.425h0c4.206,1.299,8.738.839,12.62-1.279l2.393-1.306",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "38.905 60.57 52.177 12.243 61.095 10.868" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }